// used to hardcode override values for local development
// also used to prevent reloading of a flag from remote changes
// example:
//  {"feature_learn-2790_react-poc_01-2020": false}
export default {}
